import React from "react";
import "./Footer.css";
import Logo from "../../assets/logo.png";
import { BsDiscord, BsTwitter } from "react-icons/bs";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <div className="footer-container">
      <Link to="navbar" spy={true} smooth={true}>
        <img src={Logo} alt="BearX" className="footer-logo" />
      </Link>
      <div className="footer-links">
        <a
          href="https://twitter.com/bearX_NFT"
          target="_blank"
          rel="noreferrer"
        >
          Terms & Conditions
        </a>
        <a
          href="https://twitter.com/bearX_NFT"
          target="_blank"
          rel="noreferrer"
        >
          White Paper
        </a>
        <a
          href="https://twitter.com/bearX_NFT"
          target="_blank"
          rel="noreferrer"
        >
          Smart Contract
        </a>
      </div>
      <div className="footer-buttons">
        <a
          href="https://t.co/VtmjGXDeLw?amp=1"
          target="_blank"
          rel="noreferrer"
        >
          <BsDiscord className="footer-button" />
        </a>
        <a
          href="https://twitter.com/bearX_NFT"
          target="_blank"
          rel="noreferrer"
        >
          <BsTwitter className="footer-button" />
        </a>
      </div>
      <p>All Rights Reserved 2021</p>
    </div>
  );
};

export default Footer;
